<template>
  <tr>
    <td>
      <v-simple-checkbox :value="isSelected" @click="select(!isSelected)" :ripple="false" />
    </td>
    <td><CardStudentName :student="item" /></td>
    <td>{{ item.dob | ddmmyyyy }}</td>
    <td>
      <v-chip color="yellow" text-color="black"> {{ item.status | getStatus }}</v-chip>
    </td>
    <td></td>
    <td>
      <div class="d-flex justify-end">
        <v-btn outlined color="warning" class="mr-2" @click="status = 1">Vắng mặt</v-btn>
        <v-btn outlined color="success" @click="status = 2">Có mặt</v-btn>
      </div>
    </td>
    <td>
      <div v-show="status === 1">
        <v-btn outlined color="success" class="mr-2">Đúng giờ</v-btn>
        <v-btn outlined color="warning">Vào muộn</v-btn>
      </div>
      <div v-show="status === 2">
        <v-btn outlined color="success" class="mr-2">Có phép</v-btn>
        <v-btn outlined color="warning">Không phép</v-btn>
      </div>
    </td>
  </tr>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
export default {
  components: { CardStudentName },
  props: { item: Object, expand: Function, isExpanded: Boolean, select: Function, isSelected: Boolean },
  data() {
    return { status: -1 }
  },
  filters: {
    getStatus() {
      return 'Chưa điểm danh'
    },
  },
}
</script>
